import React from 'react';
import { MainLayoutHeader, MainLayoutHeaderProps } from '@app/components';

export const FinanceHeader = ({ children }: Pick<MainLayoutHeaderProps, 'children'>) => {
  return (
    <MainLayoutHeader
      tabs={[
        { label: 'Services', screenName: 'ServiceScreen', permissions: ['dashboard::services.read'] },
        { label: 'Conformité fiscale', screenName: 'FiscalScreen', permissions: ['dashboard::fiscal.read'] },
      ]}
    >
      {children}
    </MainLayoutHeader>
  );
};
